import React from 'react';
import { Button } from 'antd';
import './index.less';

export default function StatusError({ msg = <span>抱歉出错了，请重试</span>, showBtn = true }) {
  return (
    <div className="empty-wrap">
      <div className="global-err-msg">{msg}</div>
      {showBtn && <Button onClick={() => window.location.reload()}>点击刷新</Button>}
    </div>
  );
}
